'use strict';
/* eslint-disable */

var cssConstants = {
    HIDDEN_CLASS: 'is--hidden',
    IGNORE_CLASS: 'js-ignore'
}

function initializeEvents() {
    $('.order-conf-radio-btn').find('input').change(function(){
        var id = $(this).attr('id');
        $('.order-conf-radio-btn').find('input').each(function(ele){
            var thisid = $(this).attr('id');
            if (thisid != id) {
                $(this).removeAttr('checked', false);
            }       
        });
        $('.gender-radio-'+id).attr('checked',true);
        $('#dwfrm_profile_customer_gender').val($(this).val()).trigger('change');
    });
    $('.js-accept-discount').change(function(){
        let acceptDiscount = $(this).prop('checked');
        $('.js-newsletter-discount-form').toggleClass(cssConstants.HIDDEN_CLASS + ' ' + cssConstants.IGNORE_CLASS, !acceptDiscount);
        if (!acceptDiscount) {
            $('.js-login-termsandconditions').prop('checked', false);
        }
    });
    $('.js-login-termsandconditions').change(function(){
        let loginTermsAndCond = $(this).prop('checked');
        if (loginTermsAndCond) {
            $('.show-read-more-registration').removeClass('show-read-more-error-border');
        }else{
            $('.show-read-more-registration').addClass('show-read-more-error-border');
        }
    });
    $('#confirmation-register-button').click(function(){
        let acceptDiscount = $('#RegistrationForm').find('.newsletter-section .js-accept-discount').is(':checked');
        let loginTermsAndCond = $('#RegistrationForm').find('.newsletter-section .js-login-termsandconditions').is(':checked');
        if(acceptDiscount && !loginTermsAndCond){
            $('#RegistrationForm .newsletter-section .show-read-more-registration').addClass('show-read-more-error-border');
        }
    })
}
var registeraccount = {
    init: function () {
        initializeEvents();
        $('#dwfrm_profile_customer_gender').val('3').trigger('change');
    }
};

module.exports = registeraccount;